import { Spinner } from "react-bootstrap"
import "./FormButtonComponent.scss"

const FormButtonComponent = (props) => {

    const {
        btnName, leftIcon, rightIcon,
        altText, btnAction, isPrimary,
        isDisabled, replaceClassName, showLoader, isPaymentButton, title
    } = props

    return (
        <button type="button"
            className={`${replaceClassName ? replaceClassName : 'btn-form-comp'} ${isPrimary ? 'primary-btn' : 'secondary-btn'} ${isPaymentButton ? 'paymentbtn' :''}`}
            // className="startcourse-btn"
            onClick={btnAction}
            disabled={isDisabled}
            title={title}
        >
            {
                showLoader ?
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        variant="primary"
                    />
                    :
                    <>
                        {leftIcon}
                        <span>{btnName}</span>
                        {rightIcon}
                    </>
            }
        </button>
    )

}

export default FormButtonComponent